import { FAQSection } from '@/components/sections'

export const FAQPage = () => (
  <main>
    <FAQSection />
  </main>
)
